export const Location = {
  Skaftafell: 'Skaftafell',
  Solheimajokull: 'Solheimajokull',
}

export const deviationCategories = [
  { label: 'Safety Management Plan', value: 'safety-management-plan' },
  { label: 'Staff Facility', value: 'staff-facility' },
  { label: 'Uniform', value: 'uniform' },
  { label: 'Work Hours', value: 'work-hours' },
  { label: 'Roles and Responsibilities', value: 'roles-and-responsibilities' },
  { label: 'Drugs and Alcohol', value: 'drugs-and-alcohol' },
  { label: 'Equipment', value: 'equipment' },
  { label: 'Vehicle', value: 'vehicle' },
  { label: 'Other', value: 'other' },
] as const

export const hoeyCategories = [
  { label: 'Going Above and Beyond', value: 'above-and-beyond' },
  { label: 'Teamwork', value: 'teamwork' },
  { label: 'Guest Care', value: 'guest-care' },
  { label: 'Safety Leadership', value: 'safety-leadership' },
  { label: 'Mentoring', value: 'mentoring' },
  { label: 'Problem Solving', value: 'problem-solving' },
  { label: 'Other', value: 'other' },
] as const

export const ScheduledExperienceBokunStatus = {
  SoldOut: 'SOLD_OUT',
  Available: 'AVAILABLE',
  Cancelled: 'CANCELLED',
} as const

export const ExperienceDifficulty = {
  Easy: 'Easy',
  Moderate: 'Moderate',
  Difficult: 'Difficult',
} as const

export const incidentRootCauses = [
  'Tripping/Slipping',
  'Rockfall',
  'Icefall',
  'Catching crampons',
  'Disclosed pre-existing medical condition',
  'Undisclosed pre-existing medical condition',
  'Environmental factors',
  'Equipment failure',
  'Improper use of equipment',
  'Client/Guide fitness or ability',
  'Road traffic accident',
  'Other',
] as const

export const incidentDepartureNames = [
  'Glacier Wonders',
  'Glacier Explorer',
  'Glacier Xtreme',
  'Into the Glacier',
  'Blue Ice',
  'Glacier Experience',
  'Glacier Adventure - Eco-Friendly Tour',
  'Solheimajokull Glacier Hike',
  'Skaftafellsjokull Glacier Hike',
] as const

export const incidentLocations = [
  {
    masterLocation: Location.Skaftafell,
    locations: [
      'Kings Landing',
      'At the Skaftafell booking office',
      'In the car park outside the Skaftafell booking office',
      'On route to the glacier car park',
      'In the Falljokull glacier car park',
      'In the valley',
      'In the Falljokull valley',
      'Around the terminal face of Falljokull',
      'The lower section of Falljokull',
      'The middle section of Falljokull',
      'The upper section of Falljokull',
      'Virkisjokull',
      'Other',
    ],
  },
  {
    masterLocation: Location.Solheimajokull,
    locations: [
      'Yellow Bus',
      'Solheimajokull car park',
      'Upper Solheimajokull valley',
      'Lower Solheimajokull valley',
      'Solheimajokull valley rockfall area',
      'Solheimajokull valley crampon area',
      'Solheimajokull terminal face',
      'Lower Solheimajokull',
      'Middle Solheimajokull',
      'Solheimajokull Plateau',
    ],
  },
  {
    masterLocation: 'Skaftafellsjokull',
    locations: [
      'Skaftafellsjokull',
      'Skaftafellsjokull valley walk',
      'Skaftafellsjokull lagoon',
      'Skaftafellsjokull terminal face',
      'Skaftafellsjokull ITG cave',
      'Skaftafellsjokull upper glacier',
      'Skaftafellsjokull lower glacier',
    ],
  },
] as const

export const IncidentLevel = {
  NearMiss: 'Near Miss',
  First: '1',
  Second: '2',
  Third: '3',
  Fourth: '4',
} as const

export const groupSizeMax = 16

export const GroupDirection = {
  Asc: 'Ascending',
  Desc: 'Descending',
} as const

export const clientAges = [
  '8-9',
  '10-14',
  '15-19',
  '20-24',
  '25-29',
  '30-34',
  '35-39',
  '40-44',
  '45-49',
  '50-54',
  '55-59',
  '60-64',
  '65+',
] as const

export const Gender = {
  Male: 'Male',
  Female: 'Female',
} as const

export const ClientFitness = {
  Low: 'Low',
  Medium: 'Medium',
  High: 'High',
}

export const EnvironmentalLevel = {
  Low: 'Low',
  Moderate: 'Moderate',
  High: 'High',
  Extreme: 'Extreme',
} as const

export const incidentSortCategories = [
  { label: 'Date', value: 'date' },
  { label: 'Incident Level', value: 'incident_level' },
  { label: 'Staff Involved', value: 'staff_involved' },
] as const

export const assessmentExpiry = [
  30,
  60,
  90,
  180,
  365,
] as const
